import React from "react";
import {
    Box,
    Typography,
    Button,
    Chip,
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

const ProductAttributes = ({ 
    attributes, 
    onOpenAttributesPanel, 
    onEditAttribute, 
    onRemoveAttribute,
    isAttributesSaved = true, 
    t 
}) => {
    return (
        <Box sx={{ mt: 2, mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                    {t('product.detail.attributes')}
                    {attributes && attributes.length > 0 && (
                        <Chip 
                            size="small" 
                            label={attributes.length} 
                            sx={{ ml: 1, height: 20, fontSize: '0.75rem' }}
                        />
                    )}
                </Box>
                <Button 
                    variant="outlined" 
                    size="small" 
                    startIcon={<Icon name={isAttributesSaved ? "view" : "edit"} />}
                    onClick={onOpenAttributesPanel}
                >
                    {isAttributesSaved ? t('common.view') : t('common.edit')}
                </Button>
            </Typography>
            
            {attributes && attributes.length > 0 ? (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {attributes.map((attribute, index) => (
                        <Chip 
                            key={index}
                            label={`${attribute.name} (${attribute.values.length})`}
                            onClick={isAttributesSaved ? onOpenAttributesPanel : () => onEditAttribute(index)}
                            onDelete={isAttributesSaved ? undefined : () => onRemoveAttribute(index)}
                            color="primary"
                            variant="outlined"
                            sx={{ m: 0.5 }}
                        />
                    ))}
                </Box>
            ) : (
                <Typography color="textSecondary" variant="body2">
                    {t('product.detail.noAttributes')}
                </Typography>
            )}
        </Box>
    );
};

export default ProductAttributes;